const loginPageStyles = {
  loginContainer: {
    padding: "20px",
  },
};

export default loginPageStyles;
